<select class="cell-status form-select" [disabled]="!statut.canEdit"
        [(ngModel)]="statusType" (change)="updateStatus()">
  <option [value]="'A_VOIR'" selected>A VOIR</option>
  <option [value]="'VUE'">VUE</option>
  <option [value]="'PREPAREE'">PREPAREE</option>
  <option [value]="'PLANIFIEE'" disabled>PLANIFIEE</option>
  <option [value]="'TERMINEE'">TERMINEE</option>
  <option [value]="'ANNULEE'">ANNULEE</option>
</select>
